module.exports = __webpack_public_path__ + "static/media/Mallorca Way, San Francisco, CA1.8e61f8db.jpg";